<app-modal-wrapper
  [title]="title"
  [isDirty]="isDirty"
  [formValid]="true"
  [showSaveButton]="showSaveButton"
  (save)="onSave()"
  (closeRequest)="onCancel()"
>
  <div class="flex flex-col gap-2 h-full">
    <div
      *ngIf="instructionName && onOpenInstruction"
      class="flex items-center gap-2 -mt-1"
    >
      <button
        type="button"
        class="flex items-center gap-1 text-xs font-semibold text-[var(--primary-500)] hover:underline"
        pTooltip="Open instruction: {{ instructionName }}"
        tooltipPosition="bottom"
        tooltipStyleClass="custom-tooltip"
        (click)="openInstruction()"
      >
        <i class="pi pi-external-link"></i>
        {{ instructionName }}
      </button>
    </div>

    <label class="font-bold text-gray-700 text-xs uppercase tracking-wide">
      Content
    </label>

    <textarea
      [(ngModel)]="text"
      (ngModelChange)="onTextChange($event)"
      rows="8"
      placeholder="Type your remark here..."
      class="w-full p-3 text-sm border border-gray-300 rounded-lg bg-gray-50 text-gray-700 placeholder-gray-400 focus:bg-white focus:border-[var(--primary-500)] focus:ring-1 focus:ring-[var(--primary-500)] outline-none resize-none h-full transition-all mb-2"
    ></textarea>
  </div>
</app-modal-wrapper>
